import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import HelpIcon from '../../shared/HelpIcon';
import InlineHelpText from '../../shared/InlineHelpText';
import SvgCheckMarkIcon from '../../svg/CheckMarkIcon';
import SvgUserSolid from '../../svg/UserSolid';
import SvgPencilIcon from '../../svg/PencilIcon';
import SvgXIcon from '../../svg/XIcon';
import UserStatusDisplay from '../UserStatusDisplay';
import { editUserNotes } from '../../../redux/actions/userActions';
import SvgOpenExternal from '../../svg/OpenExternal';
import {
  activeUnitText,
  emptyText,
  noneSelectedText,
  unitNameText,
  phoneText,
  // massnotificationText,
  notesText,
  hl7ResidentIdText,
  hl7VisitIdText,
  hl7VisitNameText,
} from '../../shared/SharedInternationalizations';
import Table from '../../shared/table/Table';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';
import MediaImage from '../../ui/MediaImage';

export function UnconnectedUserInfo(props) {
  const { user, currentLocation, unitsObj, noCacheImage = false } = props;
  const {
    id,
    username,
    first_name,
    last_name,
    email,
    hl7,
    phone,
    // mass_notification,
    date_of_birth,
    units,
    is_active,
    gender,
    notes,
    photo,
    status,
    active_unit,
  } = user;

  const unitsArray = Object.keys(unitsObj);

  let formattedDOB = '';
  if (date_of_birth) {
    const dobArr = date_of_birth.split('-');
    formattedDOB = `${dobArr[1]}-${dobArr[2]}-${dobArr[0]}`;
  }

  const quickEditUnitsText = (
    <FormattedMessage
      id="userDisplay.quickEditUnitsText"
      defaultMessage="Quick Edit Units"
      description="A link to open the interface to edit the units assigned to this user"
    />
  );

  const [showActiveUnitHelpText, setShowActiveUnitHelpText] = useState(false);
  function toggleActiveUnitHelpText(value) {
    setShowActiveUnitHelpText(value);
  }
  const activeUnitHelpTextRef = useRef();
  const activeUnitHelpText = (
    <FormattedMessage
      id="userDisplay.activeUnitHelpText"
      defaultMessage="This is the active unit for this user. The active unit is the unit that the user is primarily using."
      description="Help text for understanding what the active unit is"
    />
  );

  const [showContactPhoneHelpText, setShowContactPhoneHelpText] = useState(
    false
  );

  function toggleContactPhoneHelpText(value) {
    setShowContactPhoneHelpText(value);
  }
  const contactPhoneHelpTextRef = useRef();
  const contactPhoneHelpText = (
    <FormattedMessage
      id="userDisplay.contactPhoneHelpText"
      defaultMessage="This is the contact phone number for this user. This number is the number that the user would prefer to be contacted through and may be a personal number or other number. This may or may not be the same as a phone number used for alerts."
      description="Help text for understanding what the contact phone is"
    />
  );

  
  // const [showMassnotificationContactHelpText, setShowMassnotificationContactHelpText] = useState(
  //   false
  // );
  // function toggleMassnotificationContactHelpText (value) {
  //   setShowMassnotificationContactHelpText(value);
  // }
  // const massnotificationsContactHelpTextRef = useRef();
  // const massnotificationContactHelpText = (
  //   <FormattedMessage
  //   id="userDisplay.massnotificationsContactHelpText"
  //   defaultMessage= "This is the mass notification contact phone number for this user. This is the number that the user prefer to be contacted during a high priority moment. This may not be the same as a phone number used for alerts. "
  //   description="Help text for understanding what mass notification contact is "
  //    />
  //    );
  

  const [showContactEmailHelpText, setShowContactEmailHelpText] = useState(
    false
  );
  function toggleContactEmailHelpText(value) {
    setShowContactEmailHelpText(value);
  }
  const contactEmailHelpTextRef = useRef();
  const contactEmailHelpText = (
    <FormattedMessage
      id="userDisplay.contactEmailHelpText"
      defaultMessage="This is the contact email address for this user. This email is the email address that the user would prefer to be contacted through and may be a personal email or other email. This may or may not be the same as an email address used for alerts."
      description="Help text for understanding what the contact email is"
    />
  );

  const [showUserNameHelpText, setShowUserNameHelpText] = useState(false);
  function toggleUserNameHelpText(value) {
    setShowUserNameHelpText(value);
  }
  const userNameHelpTextRef = useRef();
  const userNameHelpText = (
    <FormattedMessage
      id="userDisplay.userNameHelpText"
      defaultMessage="This is the username for this user. If this user does not log into SARA, this is used only for database purposes and is an auto-generated username."
      description="Help text for understanding what the username is"
    />
  );

  const [showNotesTitleHelpText, setShowNotesTitleHelpText] = useState(false);
  function toggleNotesTitleHelpText(value) {
    setShowNotesTitleHelpText(value);
  }
  const notesHelpTextRef = useRef();
  const notesHelpText = (
    <FormattedMessage
      id="userDisplay.notesHelpText"
      defaultMessage="These are notes about the user that can be entered for future reference."
    />
  );

  const [showUnitsHelpText, setShowUnitsHelpText] = useState(false);
  function toggleUnitsHelpText(value) {
    setShowUnitsHelpText(value);
  }
  const unitsHelpTextRef = useRef();
  const unitsHelpText = (
    <FormattedMessage
      id="userDisplay.unitsHelpText"
      defaultMessage="These are the units that this user is currently assigned to."
      description="Help text for understanding what the assigned units are."
    />
  );

  const [showQuickEditUnitsHelpText, setShowQuickEditUnitsHelpText] = useState(
    false
  );
  function toggleQuickEditUnitsHelpText(value) {
    setShowQuickEditUnitsHelpText(value);
  }

  const quickEditUnitsHelpTextRef = useRef();
  const quickEditUnitsHelpText = (
    <FormattedMessage
      id="userDisplay.quickEditUnitsHelpText"
      defaultMessage="Click this button to edit the units that this user is currently assigned to."
      description="Help text for understanding what the quick edit units button does."
    />
  );

  const [showUserReportsHelpText, setShowUserReportsHelpText] = useState(false);
  function toggleUserReportsHelpText(value) {
    setShowUserReportsHelpText(value);
  }
  const userReportsHelpTextRef = useRef();
  const userReportsHelpText = (
    <FormattedMessage
      id="userDisplay.userReportsHelpText"
      defaultMessage="Clicking on this link will take you to the page to generate reports for a user."
      description="Help text for understanding what the active unit is"
    />
  )

  const [hl7ShowHelpText, setHl7ShowHelpText] = useState(false);
  function toggleHl7HelpText(value) {
    setHl7ShowHelpText(value);
  }
  const hl7HelpTextRef = useRef();
  const hl7HelpText = (
    <FormattedMessage
      id="userDisplay.hl7HelpText"
      defaultMessage="HL7 info associated with user"
      description="Help text for HL7 info table section"
    />
  );

  let userImage = (
    <div className="user-card__user-image">
      <AccessControl
        data-test="access-control"
        feature={permissions.static.users.editUser}
        userToEdit={id}>
        {is_active ? (
          <Link
            data-test="user-image-edit-link"
            className="user-card__user-image-edit-icon"
            to={`/users/${id}/edit/?mode=userImageEdit`}
            state={{
              modal: true,
              previous: currentLocation,
            }}>
            <SvgPencilIcon />
          </Link>
        ) : (
          ''
        )}
      </AccessControl>
      <SvgUserSolid data-test="user-generic-image" />
    </div>
  );
  if (photo && photo.http_path) {
    userImage = (
      <div data-test="user-api-image" className="user-card__user-image">
        <AccessControl
          data-test="access-control"
          feature={permissions.static.users.editUser}
          userToEdit={id}>
          {is_active ? (
            <Link
              data-test="user-image-edit-link"
              className="user-card__user-image-edit-icon"
              to={`/users/${id}/edit/?mode=userImageEdit`}
              state={{
                modal: true,
                previous: currentLocation,
              }}>
              <SvgPencilIcon />
            </Link>
          ) : (
            ''
          )}
        </AccessControl>

        <MediaImage
          alt="User profile"
          className="user-display__user-image"
          url={photo.http_path}
          refreshTrigger={noCacheImage}
        />
      </div>
    );
  }

  const [showNotesEdit, setShowNotesEdit] = useState(false);
  const [newNotes, setNewNotes] = useState(notes);
  function toggleNotesEditing() {
    setShowNotesEdit(!showNotesEdit);
  }

  function updateNotes(event) {
    setNewNotes(event.target.value);
  }

  function submitNotes() {
    const updatedNotes = {
      id: id,
      notes: newNotes,
      first_name: first_name,
      last_name: last_name,
    };

    props.dispatch(editUserNotes(updatedNotes));
    setShowNotesEdit(false);
  }

  function userNotesDisplay() {
    if (showNotesEdit) {
      return (
        <React.Fragment>
          <textarea
            value={newNotes}
            onChange={updateNotes}
            className="width-100"
          />
          <SvgCheckMarkIcon
            className="user-status__edit-button margin-right-5 margin-left-5 user-status__edit-button--confirm"
            onClick={submitNotes}
            data-test="check-icon"
          />
          <SvgXIcon
            onClick={toggleNotesEditing}
            className="user-status__edit-button user-status__edit-button--cancel"
            data-test="x-icon"
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {notes ? (
            notes
          ) : (
            <span className="text-dimmed margin-right-10">{emptyText}</span>
          )}
          <AccessControl
            data-test="access-control"
            feature={permissions.static.users.editUser}
            userToEdit={id}>
            {is_active ? (
              <SvgPencilIcon
                onClick={toggleNotesEditing}
                className="user-status__edit-button"
                data-test="notes-pencil-icon"
              />
            ) : (
              ''
            )}
          </AccessControl>
        </React.Fragment>
      );
    }
  }

  let userActiveUnit = { name: '' };
  if (active_unit) {
    if (unitsObj[active_unit]) {
      userActiveUnit = unitsObj[active_unit];
    }
  }

  function activeUnitDisplay() {
    if (active_unit) {
      return is_active ? (
        <Link
          data-test="active-unit-link"
          className="dropdown-menu__menu-content-item link-text margin-bottom-10"
          to={`/units/${active_unit}/view/`}
          state={{
            previous: currentLocation,
          }}>
          {userActiveUnit.name}
          <SvgOpenExternal className="margin-left-5 text-small" />
        </Link>
      ) : (
        ''
      );
    } else {
      return <span className="text-dimmed">{noneSelectedText}</span>;
    }
  }

  function userNameDisplay() {
    if (!username.includes('gen_', 0)) {
      return (
        <div
          className="content-display__column content-display__column--1-2"
          data-test="call-for-checkin-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="userInfo.userNameText"
                  defaultMessage="Username"
                  description="The user's contact phone number"
                />
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-username">
                {username}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                toggled={showUserNameHelpText}
                onClick={() => userNameHelpTextRef.current.toggleHelpText()}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={userNameHelpTextRef}
            toggleFunction={toggleUserNameHelpText}
            message={userNameHelpText}
          />
        </div>
      );
    } else {
      return '';
    }
  }

  /**
   * Function to generate the units table
   * @returns {object} - The table of units
   */
  const unitsTable = () => {
    const userUnits = units;
    // map over the units and put into the format that is required for the table component

    if (userUnits && userUnits.length > 0 && unitsArray.length > 0) {
      const unitArray = userUnits.map((u) => {
        const unit = unitsObj[u];
        const unitLink = (
          <FormattedMessage
            id="userDisplay.unitFullViewButton"
            defaultMessage="View Unit"
            description="Button to view full unit info">
            {(txt) => (
              <div className="width-100 flex-end height-100 align-center">
                <Link
                  to={`/units/${unit.id}/view/`}
                  className="text-small margin-right-10 link-text align-center">
                  {txt} <SvgOpenExternal className="margin-left-5" />
                </Link>
              </div>
            )}
          </FormattedMessage>
        );
        return {
          name: {
            sortBy: unit.name.toUpperCase(),
            display: unit.name,
          },
          fullView: {
            sortBy: '',
            display: unitLink,
          },
        };
      });
      // Take the array and filter based on the text entered in the search bar.

      const tableHeadings = [
        {
          isSortable: true,
          sortBy: 'name',
          display: unitNameText,
        },
      ];
      // generates the actual table
      const table = (
        <Table
          hasTableHead={false}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="name"
          tableData={unitArray}
          tableStyles="table__constrained table-layout__2-column"
          data-test="units-table"
        />
      );
      return table;
    } else {
      return (
        <span className="text-dimmed margin-right-10" data-test="no-units">
          <FormattedMessage
            data-test="no-parent-text"
            id="userInfo.noUnits"
            defaultMessage="No Units Associated"
            description="Label indicating that there is no parent unit for the current unit"
          />
        </span>
      );
    }
  };

  /**
   * Function to generate the units table
   * @returns {object} - The table of units
   */
  const hl7Table = () => {
    if (hl7 && hl7.length > 0) {
      const hl7Array = hl7.map((h) => {
        return {
          rid: {
            sortBy: h.rid,
            display: h.rid,
          },
          visit_id: {
            sortBy: h.visit_id,
            display: h.visit_id,
          },
          visit_name: {
            sortBy: h.visit_name,
            display: h.visit_name,
          },
        };
      });

      const tableHeadings = [
        {
          isSortable: false,
          sortBy: 'rid',
          display: hl7ResidentIdText,
        },
        {
          isSortable: false,
          sortBy: 'visit_id',
          display: hl7VisitIdText,
        },
        {
          isSortable: false,
          sortBy: 'visit_name',
          display: hl7VisitNameText,
        },
      ];
      // generates the actual table
      const table = (
        <Table
          hasTableHead={true}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="rid"
          tableData={hl7Array}
          tableStyles="table__constrained table-layout__3-column"
          data-test="hl7-table"
        />
      );
      return table;
    } else {
      return (
        <span className="text-dimmed margin-right-10" data-test="no-units">
          <FormattedMessage
            data-test="no-parent-text"
            id="userInfo.noHl7"
            defaultMessage="No HL7 Info"
            description="Label indicating this user has no associated HL7 info"
          />
        </span>
      );
    }
  };

  return (
    <div className="content-display__container" data-test="content-container">
      <div
        className="content-display__column content-display__column--1-3"
        data-test="user-image-container">
        <div className="content-display__item-pill-container">
          <div className="item-container__main-container">
            {userImage}

            <UserStatusDisplay
              userId={id}
              userStatus={status}
              first_name={first_name}
              last_name={last_name}
              is_active={is_active}
            />
          </div>
        </div>
      </div>
      <div
        className="content-display__column content-display__column--2-3 content-display__container"
        data-test="call-for-checkin-container">
        <div
          className="content-display__column content-display__column--1-2"
          data-test="active-unit-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {activeUnitText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-active-unit-link">
                {activeUnitDisplay()}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                styles="margin-left-5"
                onClick={() => activeUnitHelpTextRef.current.toggleHelpText()}
                toggled={showActiveUnitHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={activeUnitHelpTextRef}
            toggleFunction={toggleActiveUnitHelpText}
            message={activeUnitHelpText}
          />
        </div>
        <div
          className="content-display__column content-display__column--1-2"
          data-test="user-phone-number-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {phoneText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-phone">
                {phone ? (
                  phone
                ) : (
                  <span className="text-dimmed">{emptyText}</span>
                )}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                styles="margin-left-5"
                onClick={() => contactPhoneHelpTextRef.current.toggleHelpText()}
                toggled={showContactPhoneHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={contactPhoneHelpTextRef}
            toggleFunction={toggleContactPhoneHelpText}
            message={contactPhoneHelpText}
          />
        </div>

        
       

                  
      {/* <div
          className="content-display__column content-display__column--1-2"
          data-test="user-massnotification-contact-number-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {massnotificationText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-massnotification-contact">
                {mass_notification? (
                  mass_notification
                ) : (
                  <span className="text-dimmed">{emptyText}</span>
                )}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                styles="margin-left-5"
                onClick={() => massnotificationsContactHelpTextRef.current.toggleHelpText()}
                toggled={showMassnotificationContactHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={ massnotificationsContactHelpTextRef}
            toggleFunction={toggleMassnotificationContactHelpText}
            message={massnotificationContactHelpText}
          />
        </div> */}




        {userNameDisplay()}
        <div
          className="content-display__column content-display__column--1-2"
          data-test="gender-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="userInfo.genderText"
                  defaultMessage="Gender"
                  description="The user's gender"
                />
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-gender">
                {gender ? (
                  gender
                ) : (
                  <span className="text-dimmed">{emptyText}</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="content-display__column content-display__column--1-2"
          data-test="date-of-birth-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="userInfo.dateOfBirthText"
                  defaultMessage="Date of Birth"
                  description="The user's date of birth"
                />
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-date-of-birth">
                {date_of_birth ? (
                  formattedDOB
                ) : (
                  <span className="text-dimmed">{emptyText}</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="content-display__column content-display__column--1-2"
          data-test="directory-email-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container item-container__main-container--after">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="userEmail.contactEmailText"
                  defaultMessage="Directory Email"
                  description="The user's contact phone number"
                />
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="user-email">
                {email ? (
                  <a
                    href={`mailto:${email}`}
                    className="link-text"
                    data-test="user-email-link">
                    {email}
                  </a>
                ) : (
                  <span className="text-dimmed">{emptyText}</span>
                )}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => contactEmailHelpTextRef.current.toggleHelpText()}
                toggled={showContactEmailHelpText}
                styles="margin-left-5"
              />
            </div>
          </div>
          <InlineHelpText
            ref={contactEmailHelpTextRef}
            toggleFunction={toggleContactEmailHelpText}
            message={contactEmailHelpText}
          />
        </div>
      </div>
      <div className="content-display__column" data-test="notes-container">
        <div className="content-display__item-pill-container">
          <div className="item-container__main-container">
            <div className="item-container__main-text text-large text-light">
              {notesText}
            </div>
            <div
              className="item-container__secondary-text text-medium text-bold flex-row align-center"
              data-test="user-notes">
              {userNotesDisplay()}
            </div>
          </div>
          <div className="item-container__info-container">
            <HelpIcon
              styles="margin-left-5"
              onClick={() => notesHelpTextRef.current.toggleHelpText()}
              toggled={showNotesTitleHelpText}
            />
          </div>
        </div>
        <InlineHelpText
          ref={notesHelpTextRef}
          toggleFunction={toggleNotesTitleHelpText}
          message={notesHelpText}
        />
      </div>
      <div
        className="content-display__column"
        data-test="assigned-units-container">
        <div className="content-display__item-pill-container">
          <div className="item-container__main-container">
            <div className="item-container__main-text text-large text-light">
              <FormattedMessage
                id="userInfo.assignedUsersText"
                defaultMessage="Assigned Units:"
                description="The assigned units for this user"
              />
              <HelpIcon
                onClick={() => unitsHelpTextRef.current.toggleHelpText()}
                toggled={showUnitsHelpText}
                styles="margin-left-5"
              />
            </div>
            <div className="item-container__secondary-text text-medium text-bold flex-row align-center">
              {unitsTable()}
            </div>
          </div>
          <AccessControl
            data-test="access-control"
            feature={permissions.static.users.editUser}
            userToEdit={id}>
            {is_active ? (
              <div className="item-container__info-container">
                <Link
                  data-test="associate-units-to-user"
                  className="link-button button-secondary button-xsm text-small"
                  to={`/users/${id}/edit/?mode=associateUnits`}
                  state={{
                    modal: true,
                    previous: currentLocation,
                  }}
                >
                  {quickEditUnitsText}
                </Link>
                <HelpIcon
                  onClick={() =>
                    quickEditUnitsHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showQuickEditUnitsHelpText}
                  styles="margin-left-5"
                />
              </div>
            ) : (
              ''
            )}
          </AccessControl>
        </div>
        <InlineHelpText
          ref={unitsHelpTextRef}
          toggleFunction={toggleUnitsHelpText}
          message={unitsHelpText}
        />
        <InlineHelpText
          ref={quickEditUnitsHelpTextRef}
          toggleFunction={toggleQuickEditUnitsHelpText}
          message={quickEditUnitsHelpText}
        />
      </div>

      <AccessControl
        data-test="access-control"
        feature={permissions.static.users.editUser}
        userToEdit={id}>
        {is_active ? (
          <div
            className="content-display__column  content-display__column--1-2"
            data-test="user-reports-container">
            <div className="content-display__item-pill-container">
              <div className="item-container__main-container">
                <div className="item-container__main-text text-large text-light">
                  <FormattedMessage
                    id="userDisplay.userReportsText"
                    defaultMessage="Generate User Reports"
                    description="A link to open the interface to edit the units assigned to this user">
                    {(txt) => (
                      <a
                        data-test="user-reports-link"
                        className="link-text"
                        href={`/resinfo/resident_reports.php?user_id=${id}`}>
                        {txt}
                        <SvgOpenExternal className="margin-left-10" />
                      </a>
                    )}
                  </FormattedMessage>
                </div>
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() =>
                    userReportsHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showUserReportsHelpText}
                  styles="margin-left-5"
                />
              </div>
            </div>

            <InlineHelpText
              ref={userReportsHelpTextRef}
              toggleFunction={toggleUserReportsHelpText}
              message={userReportsHelpText}
            />
          </div>
        ) : (
          ''
        )}
      </AccessControl>

      {/* HL7 Info Section */}
      {user.hl7 && user.hl7.length > 0 ? (
        <div
          className="content-display__column"
          data-test="hl7-info-container">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="userInfo.hl7TitleText"
                  defaultMessage="HL7:"
                  description="The associated HL7 data for this user"
                />
                <HelpIcon
                  onClick={() => hl7HelpTextRef.current.toggleHelpText()}
                  toggled={hl7ShowHelpText}
                  styles="margin-left-5"
                />
              </div>
              <InlineHelpText
                ref={hl7HelpTextRef}
                toggleFunction={toggleHl7HelpText}
                message={hl7HelpText}
              />
              <div className="item-container__secondary-text text-medium text-bold flex-row align-center">
                {hl7Table()}
              </div>
            </div>
          </div>
          <InlineHelpText
            ref={unitsHelpTextRef}
            toggleFunction={toggleUnitsHelpText}
            message={unitsHelpText}
          />
        </div>
      ) : (
        ''
      )
    }
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    unitsObj: state.units.units,
  };
};

function UserInfoWrapper(props) {
  const location = useLocation();
  const ConnectedUserInfo = connect(mapStateToProps)(UnconnectedUserInfo);
  return <ConnectedUserInfo {...props} noCacheImage={location?.state?.noCacheImage || false} />;
}

export default UserInfoWrapper;
